"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isAllItems = exports.ALL_ITEMS = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var ALL_ITEMS = '*';
exports.ALL_ITEMS = ALL_ITEMS;

var isAllItems = function isAllItems(value) {
  return value === ALL_ITEMS;
};

exports.isAllItems = isAllItems;

var SelectFilter = function SelectFilter(_ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      name = _ref.name,
      value = _ref.value,
      renderItems = _ref.renderItems,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      onFilterChange = _ref.onFilterChange,
      helperText = _ref.helperText,
      dataTestId = _ref.dataTestId,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      selectProps = _ref.selectProps,
      formControlProps = (0, _objectWithoutProperties2["default"])(_ref, ["label", "disabled", "name", "value", "renderItems", "classes", "onFilterChange", "helperText", "dataTestId", "children", "selectProps"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var labelEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setOpen(false);
  }, [value]);
  var handleChange = (0, _react.useCallback)(function (event) {
    if (!onFilterChange) {
      return;
    }

    setOpen(false);
    onFilterChange((0, _defineProperty2["default"])({}, event.target.name, event.target.value));
  }, [onFilterChange]);
  return /*#__PURE__*/_react["default"].createElement(_material.FormControl, (0, _extends2["default"])({
    variant: "outlined",
    disabled: disabled,
    className: classes.root
  }, formControlProps), /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
    ref: labelEl,
    htmlFor: "outlined-".concat(name)
  }, label), /*#__PURE__*/_react["default"].createElement(_material.Select, (0, _extends2["default"])({}, selectProps, {
    open: open,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    onChange: onFilterChange ? handleChange : undefined,
    label: label,
    input: /*#__PURE__*/_react["default"].createElement(_material.OutlinedInput, {
      value: value,
      className: "select-label-ie",
      label: label || undefined,
      name: name,
      id: "outlined-".concat(name),
      "data-testid": dataTestId
    })
  }), renderItems ? renderItems() : children), helperText && /*#__PURE__*/_react["default"].createElement(_material.FormHelperText, null, helperText));
};

var _default = SelectFilter;
exports["default"] = _default;